<template>
  <div class="cancel">
    <div class="completerecords-three-one">
      <span>用户取消时间：</span>
      <span>{{cancelTime}}</span>
    </div>
    <div class="completerecords-three-one">
      <span>用户下单时间：</span>
      <span>{{orderTime}}</span>
    </div>
  </div>
</template>
<script>
import {formatDate} from 'common/js/util';
export default {
  props: {
    commodityListDetails: {} //数据
  },
  data() {
    return {
      orderTime: null,//用户下单时间：
      cancelTime: null //用户取消时间
    };
  },
  watch:{
     commodityListDetails: {
       handler(newVal) {
         const {cancelTime, orderTime} = newVal;
         this.orderTime = formatDate(orderTime);
         this.cancelTime = formatDate(cancelTime);
       },
       deep: true
     }
  },
  created() {
    const {orderTime, cancelTime} = this.commodityListDetails;
    if (orderTime) {
      this.orderTime = formatDate(orderTime);
    }
    if (cancelTime) {
      this.cancelTime = formatDate(cancelTime);
    }
  }
};
</script>

<style lang="scss" scoped>
.completerecords-three-one {
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.completerecords-three-one span:nth-child(1) {
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 37px;
}
.completerecords-three-one:nth-child(even) {
  margin: 24px 0;
}
.completerecords-three-one span:nth-child(2) {
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 37px;
}
</style>



// WEBPACK FOOTER //
// src/pages/completeRecords/details/cancel.vue